// extracted by mini-css-extract-plugin
export default {"TitleWithTooltip":"styles_TitleWithTooltip__e+lXO","icon":"styles_icon__g0vcP","blink-animation":"styles_blink-animation__VNH2I"};